import { isEmpty } from 'lodash';
import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const IS_LOADING = 'IS_LOADING';
export const FETCH_AVAILABLE_NUMBER_LIST = 'FETCH_AVAILABLE_NUMBER_LIST';
export const FETCH_PAGINATED_LIST = 'FETCH_PAGINATED_LIST';
export const RESET_TOTAL = 'RESET_TOTAL';
export const FETCH_MANUAL_APPROVAL_DETAILS = 'FETCH_MANUAL_APPROVAL_DETAILS';

export const SUBSCRIBE_NUMBER_ERROR = 'SUBSCRIBE_NUMBER_ERROR';
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';

export const getAvailableNumberList = (
	limit: number,
	offset: number,
	filterData?: any,
	locationData?: any,
) => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		if (offset === 0) {
			dispatch({ type: RESET_TOTAL });
		}

		let endpoint = `/available-numbers-go?limit=${limit}&offset=${
			offset * limit
		}`;

		if (filterData) {
			if (
				Object.keys(filterData).length &&
				Object.keys(filterData).length > 0
			) {
				Object.keys(filterData).forEach((key, index) => {
					if (
						filterData[key] !== undefined &&
						filterData[key] !== ''
					) {
						endpoint = `${endpoint}&${key}=${filterData[key]}`;
					}
				});
			}
		}

		if (locationData && !isEmpty(locationData)) {
            if (locationData['country_id']) { endpoint += `&country_id=${locationData['country_id']}` }
            if (locationData['state_id']) { endpoint += `&state_id=${locationData['state_id']}` }
            if (locationData['city_id']) { endpoint += `&city_id=${locationData['city_id']}` }
        }

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
				dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					if (offset === 0) {
						dispatch({
							type: FETCH_AVAILABLE_NUMBER_LIST,
							payload: {
								res: Object.values(res.data),
								total: res.total,
								balance: res.balance,
								currency: res.currency,
								countryIsoCode: res.country_iso_code,
								countryDialCode: res.country_dial_code,
								exchangeRate: res.exchange_rate,
							},
						});
					} else {
						dispatch({
							type: FETCH_PAGINATED_LIST,
							payload: {
								res: Object.values(res.data),
								total: res.total,
								balance: res.balance,
								currency: res.currency,
								countryIsoCode: res.country_iso_code,
								countryDialCode: res.country_dial_code,
								exchangeRate: res.exchange_rate,
							},
						});
					}
				} else {
					dispatch({
						type: SUBSCRIBE_NUMBER_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
				dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: SUBSCRIBE_NUMBER_ERROR,
						payload: { error },
					});
				}
			});
	};
};

export const docUpload = (
	data: any,
	cb: (data: any, uuid?: string) => void,
	onError: () => void,
	uuid: string = '',
) => {
	return () => {
		let url: string = `/document/upload`;

		networkCall('post', url, apiBaseUrl.baseUrl, true, true, data)
			.then((res: any) => {
				if (res.error && isEmpty(res.error)) {
					cb(res, uuid);
				} else {
					onError();
				}
			})
			.catch(() => {
				onError();
			});
	};
};

export const subscribeNumber = (
	data: any,
	onSuccess: (res: any) => void,
	onError: () => void
) => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = '/buy-number-go';

		networkCall('post', `${endpoint}`, apiBaseUrl.baseUrl, true, true, data)
			.then((res: any) => {
				onSuccess(res);
				dispatch({ type: IS_LOADING, payload: false });
				// if (res.data) {
				// } else {
				// }
			})
			.catch((error) => {
				onError();
				dispatch({ type: IS_LOADING, payload: false });
				// if (error?.response?.data) {
				// }
			});
	};
};

export const getManualApprovalDetails = (filterData?: any) => {
	return (dispatch: Dispatch<any>) => {
		dispatch({ type: IS_LOADING, payload: true });

		let endpoint = `/manual-approval-details`;

		if (filterData) {
			if (
				Object.keys(filterData).length &&
				Object.keys(filterData).length > 0
			) {
				Object.keys(filterData).forEach((key, index) => {
					if (
						filterData[key] !== undefined &&
						filterData[key] !== ''
					) {
						endpoint = `${endpoint}&${key}=${filterData[key]}`;
					}
				});
			}
		}

		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
				dispatch({ type: IS_LOADING, payload: false });
				if (res.data) {
					dispatch({
						type: FETCH_MANUAL_APPROVAL_DETAILS,
						payload: {
                            firstSubscription: parseInt(res.first_subscription),
                            activationDetails: res.did_activation_details,
						},
					});
				} else {
					dispatch({
						type: SUBSCRIBE_NUMBER_ERROR,
						payload: { error: res.error },
					});
				}
			})
			.catch((error) => {
				dispatch({ type: IS_LOADING, payload: false });
				if (error?.response?.data) {
					dispatch({
						type: SUBSCRIBE_NUMBER_ERROR,
						payload: { error },
					});
				}
			});
	};
};
